import Swiper from 'swiper'

const SELECTORS = {
    gallery: '.init-swiper',
    galleryItem: '.blocks-gallery-item'
}

const CLASSES = {
}

export default class GallerySwiper {
    constructor () {
        this.isLoaded = false
    }

    initialize () {
        this.galleries = Array.from( document.querySelectorAll(SELECTORS.gallery) )
        if (this.galleries.length) {
            this.galleriesItem = Array.from( document.querySelectorAll(SELECTORS.galleryItem) )

            const t = this
            import('swiper').then(function (module) {
                t.Swiper = module.default
                t.isInit()
            })
        } else {
            this.isInit()
        }
    }

    init (cb) {
        const t = this

        const initSwiperForGallery = gallery => {
            // example: wrapping an anchor with class "wrap_me" into a new div element
            const d = document.createElement('div')
            const next = document.createElement('div')
            const prev = document.createElement('div')
            Util.addClass(d, 'swiper-container')
            Util.addClass(next, 'swiper-button-next')
            Util.addClass(prev, 'swiper-button-prev')
            t.wrap( gallery,  d )
            Util.addClass(gallery, 'swiper-wrapper')
            Util.removeClass(gallery, 'wp-block-gallery')
            d.appendChild(next)
            d.appendChild(prev)
            t.galleriesItem.forEach( item => {
                Util.addClass(item, 'swiper-slide')
            } )

            const mySwiper = new Swiper(d, {
                speed: variables.transition,
                slidesPerView: 1,
                loop: true,
                autoHeight: true,
                autoplay: {
                    delay: 5000
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev
                }
            })
        }

        this.galleries.forEach( gallery => initSwiperForGallery(gallery) )
    }

    wrap (el, wrapper) {
        el.parentNode.insertBefore(wrapper, el)
        wrapper.appendChild(el)
    }


    isInit () {
        this.isLoaded = true
        App.loadProgress += 1
        App.checkAppLoaded()
    }
}
